<template>
  <tr :class="{ invited: user.status === 'pending'}">
    <td>
      <avatar :recipe="user.avatar" />
      <strong>{{ user.first_name }} {{ user.last_name }}</strong>
      <span>id : {{ user.identifier }}</span>
      <em>inscrit le {{ user.signup_date }}</em>
    </td>
    <template v-if="user.status === 'valid'">
      <td>
        <span v-if="!nextAppointment">Non disponible</span> 
        <template v-else>
          <strong>{{ nextAppointment.appointment_type }}</strong><span>{{ formatDate( nextAppointment.date, 'datetime' )}}</span>
        </template>
      </td>
      <td v-if="user.can.indexOf('see_autoevaluation') !== -1">
        <img v-if="!currentEvaluation"                 src="@/assets/images/mascotte/m-00.png" />
        <img v-else-if="currentEvaluation.value === 0" src="@/assets/images/mascotte/m-0.png" />
        <img v-else-if="currentEvaluation.value === 1" src="@/assets/images/mascotte/m-1.png" />
        <img v-else-if="currentEvaluation.value === 2" src="@/assets/images/mascotte/m-2.png" />
        <img v-else-if="currentEvaluation.value === 3" src="@/assets/images/mascotte/m-3.png" />

        <span v-if="!currentEvaluation">Pas disponible</span>
        <span class="date" v-else>{{ formatDate(currentEvaluation.date) }}</span>
      </td>
      <td v-else>
        <span>Pas disponible</span>
      </td>
      <td>
        <span v-if="!lastPlayedGame">Non disponible</span> 
        <template v-else>
          <strong>{{ lastPlayedGame.game }}</strong><span>{{ formatDate( lastPlayedGame.played_at, 'datetime' )}}</span>
        </template>
      </td>
      <td>
        <router-link :to="{ name: 'dashboard-child-preview', params: { id: user.id } }" class="button btnPush small" >Voir son carnet</router-link>
      </td>
      <td>
        <i class="fas fa-trash-alt" @click="remove"></i>
      </td>
    </template>
    <td v-else colspan="5">
    </td>
  </tr>
</template>

<script>
  import { mapActions } from 'vuex'
  import Avatar from '@/components/Avatar'
  import Bouton from '@/components/Bouton'
  import { formatDate, dateFromString } from '@/functions'

  export default {
    props: ['user'],
    components: { Avatar, Bouton },
    methods: {
      ...mapActions['addNotice', 'removeFromFamily'],
      formatDate,
      async remove() {
        await this.$store.dispatch('removeFromFamily', { familyId: this.user.mainFamilyId })
        this.$store.dispatch('addNotice', { message: `${this.user.first_name} ${this.user.last_name} a été retiré de la liste des enfants que vous suivez.`})
      }
    },
    computed: {
      currentEvaluation() {
        let autoEvaluations = this.user.auto_evaluations
        return autoEvaluations[autoEvaluations.length - 1]
      },
      lastPlayedGame() {
        let games = this.user.games.filter(g => g.played_at)
        let sorted_games = games.sort((a, b) => {
          if (a.played_at < b.played_at)
            return -1;
          if (a.played_at > b.played_at)
            return 1;
          return 0;
        })

        return sorted_games[0]
      },
      nextAppointment() {
        let now = Date.now()
        return this.user.families[0].mainAccount.appointments
          .filter(n => dateFromString(n.date) > now)
          .sort((a, b) => {
            let dateA = dateFromString(a.date)
            let dateB = dateFromString(b.date)
            if (dateA === dateB)
              return 0
            else if (dateA > dateB)
              return 1
            else if (dateA < dateB)
              return -1
          })
          [0]
      }
    }
  }
</script>

<style scoped>
   

.tableau tr span.date {
  font-family: 'blogger_sansregulat';
  font-size: 12px;
  font-style: italic;
}
   
.item-soignant {
  background: #f1f1f1;
  padding: 5px 15px;
  margin-bottom: 5px;
}

.avatar {
  transform: scale(0.4);
  transform-origin: 0 0;
	top: 5px !important;
	left: 15px !important;
  position: absolute;
}

.item-soignant .avatar img { margin: 0px;}


.item-soignant p {   
  font-size: 21px;
  color: #413492;
  line-height: 21px;
  margin-bottom: 0px;
  margin-top: 0px;
  font-family: 'blogger_sansbold';
  display: inline-block;
  min-width: 200px;
      position: relative;
    top: 15px;
  }
.item-soignant span { font-size: 18px; color: #858585; }
.item-soignant em {  font-size: 14px; color: #858585; font-family: 'blogger_sanslight'; }
.item-soignant .rapport {  
  border-left: 1px solid #ccc; 
  border-right: 1px solid #ccc; 
  padding: 0 20px;
  font-size: 24px;
  display: inline-block;
  margin-right: 25px;
  float: right;
  margin-top: 30px;
}
.item-soignant .rapport .fa-check-circle {  
  color: #36bf2e;
  margin-right: 25px;
}

.item-soignant .rapport .fa-times {  
  color: #de2128;
}
.item-soignant .fa-trash-alt {  
  color: #a6a6a6;
  font-size: 24px;
  cursor: pointer; 
  float: right;
  margin-top: 37px;
}
.item-soignant .fa-trash-alt:hover {  color: #de2128;  }
.item-soignant.on .rapport .fa-times {   color: #a6a6a6; cursor: pointer; }
.item-soignant.on .rapport .fa-times:hover {   color: #de2128; }

.item-soignant.off .rapport .fa-check-circle {   color: #a6a6a6; cursor: pointer; }
.item-soignant.off .rapport .fa-check-circle:hover {   color: #36bf2e; }

@media (max-width: 1300px) { .item-soignant p {    min-width: 150px; } }

@media (max-width: 500px) {

  .item-soignant .avatar {display: none;}
  .item-soignant p {min-height: 90px;}
  .item-soignant .rapport .fa-check-circle {  margin-right: 15px; }
  .item-soignant .rapport {    padding: 0 12px; font-size: 20px; }
  .item-soignant .fa-trash-alt { font-size: 15px; }
}

.invited {
  opacity: 0.6;
}

</style>
